// Translated
// Migrated
<template>
  <div class="multi-video-player w-full">
    <div
      v-if="sortedMovies.length > 0"
      class="multi-video-player__main relative size-full m-auto"
    >
      <slot
        v-if="!currentMovie"
        name="loading"
      />
      <MediaPlayer
        v-else
        v-bind="mediaPlayerProps"
        :url="currentMovie?.url"
        :type="currentMovie?.type"
        :autoplay="playMainFrame"
      />
    </div>
    <div
      v-if="sortedMovies.length > 1"
      class="flex flex-wrap -mx-4 my-4"
    >
      <div
        v-for="(movie, idx) in sortedMovies"
        :key="`${idx}_${movie.id}`"
        class="multi-video-player__preview w-4/12 my-2"
        :class="{ active: currentIdx === idx }"
      >
        <MediaPlayer
          v-bind="mediaPlayerProps"
          :url="movie?.url"
          :type="movie?.type"
          :autoplay="false"
          just-preview
          @play="onPlay(idx)"
        />
        <strong class="block text-center">
          {{ movie?.text }}
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
import MediaPlayer from '@packages/media/components/MediaPlayer.vue'

export default defineNuxtComponent({
  props: {
    ...MediaPlayer.props,

    movies: {
      type: Array,
      default: () => [],
    },

    autoplay: {
      type: Boolean,
      default: false,
    },

    aspectRatio: {
      type: [String, Boolean],
      default: '16/9',
    },

    justPreview: {
      type: Boolean,
      default: false,
    },

    isHotelGallery: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      play: false,
      currentIdx: 0,
    }
  },

  computed: {
    currentMovie () {
      return this.sortedMovies[this.currentIdx]
    },

    playMainFrame () {
      return this.autoplay || this.play
    },

    sortedMovies () {
      return deepClone(this.movies || [])
        .sort((a, b) => (a?.movie_prio || 99) - (b?.movie_prio || 99))
    },

    mediaPlayerProps () {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
      const { movies, autoplay, ...mediaPlayerProps } = this.$props
      return mediaPlayerProps
    },
  },

  methods: {
    onPlay (idx) {
      this.currentIdx = idx
      this.play = true
    },
  },
})
</script>

<style lang="scss">
.multi-video-player {
  &__main {
    width:100%;
    max-width: theme('screens.xl');
  }
  &__preview {
    &.active {
      .media-player:before {
        content: "\a0";
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background: theme('colors.primary');
        opacity: .65;
        position: absolute;
        z-index: 4;
      }
    }
  }
}
</style>
